import { requestV2 } from "../../helpers/request";
import { baseEndpoint } from "../mnt-api";

//* Request Developments
const pathDevelopments = "/developments";

export async function fetchDevelopments(filter = {}) {
  return requestV2({
    endpoint: `${baseEndpoint}${pathDevelopments}`,
    bodyRequest: filter,
    defaultResponse: []
  });
}
export async function fetchDevelopmentsByInmoId(inmoId) {
  return requestV2({
    endpoint: `${baseEndpoint}${pathDevelopments}?group=${inmoId}`,
    defaultResponse: []
  });
}

export async function fetchDevelopmentDetail(id) {
  return requestV2({
    endpoint: `${baseEndpoint}${pathDevelopments}/${id}`,
    defaultResponse: {}
  });
}

export async function editDevelopment(id, data) {
  return requestV2({
    endpoint: `${baseEndpoint}${pathDevelopments}/${id}/update`,
    bodyRequest: data,
    defaultResponse: {}
  });
}

export async function fetchDevelopmentInventory(id) {
  return requestV2({
    endpoint: `${baseEndpoint}${pathDevelopments}/${id}/inventory`,
    defaultResponse: []
  });
}

export async function deleteDevelopmentInventory(id) {
  return requestV2({
    endpoint: `${baseEndpoint}${pathDevelopments}/${id}/inventory/delete`,
    defaultResponse: {}
  });
}
